import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { IAttributeConfData } from '@df/catalog-ui/product/configurable-options/product-configurable-options.component.def';
import { IProductDataV3 } from '@df/catalog/product/product';
import { OptionLabelPipe } from '@df/ui/common/option-label.pipe';
import { DfUiModule } from '@df/ui/df-ui.module';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { SwatchComponent } from 'projects/app-default/src/app/catalog/attribute/swatch/swatch.component';
import { ConfigurableOptionWarningTriggerDirective } from 'projects/app-default/src/app/catalog/ui/product/configurable-options/configurable-option-warning/configurable-option-warning.trigger.directive';
import { ProductConfigurableOptionDropdownComponent } from 'projects/app-default/src/app/catalog/ui/product/configurable-options/dropdown/product-configurable-option-dropdown.component';
import { ProductConfigurableOptionsComponent } from 'projects/app-default/src/app/catalog/ui/product/configurable-options/product-configurable-options.component';
import { SizebayComponent } from 'projects/app-default/src/app/module/sizebay/sizebay.component';
@Component({
    selector: 'builder-product-configurable-options',
    templateUrl: 'builder-product-configurable-options.html',
    styleUrls: ['builder-product-configurable-options.scss'],
    standalone: true,
    imports: [
        NgClass,
        OptionLabelPipe,
        TranslationModule,
        SwatchComponent,
        DfUiModule,
        ProductConfigurableOptionDropdownComponent,
        ConfigurableOptionWarningTriggerDirective,
        SizebayComponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
// Extends local component to get proper warnings for options
export class BuilderProductConfigurableOptionsComponent extends ProductConfigurableOptionsComponent {
    @Input()
    smallVariant = false;

    override setAttributes(attributes?: IAttributeConfData[]): void {
        attributes?.forEach(attr =>
            attr.options.filter(
                o =>
                    (attr.code == 'color'
                        ? o.product.data?.eligible_builder ||
                          (o.product.parent?.data as IProductDataV3)?.eligible_builder ||
                          o.product.data?.toy_eligible_builder ||
                          (o.product.parent?.data as IProductDataV3)?.toy_eligible_builder
                        : true) && this.product.isConfigurableOptionSalable(attr.code, o)
            )
        );
        super.setAttributes(attributes as any);
    }

    override initSelection(): void {
        super.initSelection();
        // preselect option if only one option for current color
        if (this.product.isConfigurable && this.data['color']) {
            const data = this.data || {};
            this.attributes.forEach((attribute: IAttributeConfData) => {
                const options = attribute.options.filter(o => o.product?.data?.color === this.data['color']);
                if (options?.length === 1) {
                    data[attribute.code] = options[0].value;
                }
            });
            this.data = data;
        }
    }
}
